export enum Roles {
    Admin = 'System Administrator',
    MultiTenantRO = 'Multi-Tenant Read Only',
    GlobalRoleManager = 'Global Role Manager',
    AppManager = 'Application Manager',
    UserManager = 'User Manager'
}

export enum TenantGlobalRoles {
    Administrator = 'Tenant Administrator',
    TenantRO = 'Tenant Read-Only',
    TenantACLManager = 'Tenant ACL Manager'
}
